import React, {FC, useEffect, useState} from 'react';
import {Modal, Button, Typography, Spin, message as antdMessage} from 'antd';
import {useNavigate} from 'react-router-dom';
import authService from '../../../services/authService';
import * as authActions from "../../../store/modules/auth/actions";
import {useDispatch} from "react-redux";
import productService from "../../../services/productService";
import {handleLogout} from "../../../utils/helpers";

const {Title, Paragraph, Text} = Typography;

const UpgradeSuccessPage: FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [previousRole, setPreviousRole] = useState<string | ''>('');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const checkProfile = async () => {
            try {
                const result = await authService.getProfile();
                dispatch(authActions.loginSuccess(true, result.data));
                setPreviousRole(result.data.previousRole);
            } catch (error: any) {
                console.error(error);
                setError('Failed to verify your account previous role.');
            } finally {
                setLoading(false);
            }
        };
        checkProfile();
    }, []);

    const onLogout = () => {
        handleLogout(dispatch, navigate)();
    };

    const handleUpgradeToPartner = async () => {
        try {
            const response = await productService.createPortalSession({action: "upgrade_to_partner"});
            if (response?.data?.url) {
                window.location.href = response.data.url;
            } else {
                antdMessage.error('No portal URL received');
            }
        } catch (err: any) {
            antdMessage.error(err.message || 'Error creating portal session.');
        }
    };

    if (loading) return <Spin style={{margin: 20}}/>;

    if (error) {
        return (
            <Modal visible title="Something went wrong" footer={null} closable={false} maskClosable={false}>
                <Text type="danger">{error}</Text>
                <div style={{textAlign: 'right', marginTop: 16}}>
                    <Button onClick={() => navigate('/profile')}>Go to Profile</Button>
                </div>
            </Modal>
        );
    }

    if (previousRole !== 'promoter') {
        return (
            <Modal visible title="Upgrade Incomplete" footer={null} closable={false} maskClosable={false}>
                <Title level={4}>Almost there!</Title>
                <Paragraph>
                    It looks like your upgrade to a Partner account in Promotify wasn’t completed.
                    Please click the button below, choose the Partner plan that suits you best, and make sure to
                    complete the process before returning here.
                </Paragraph>
                <div style={{textAlign: 'right'}}>
                    <Button type="primary" onClick={handleUpgradeToPartner}>Upgrade to partner</Button>
                </div>
            </Modal>
        );
    }

    return (
        <Modal visible title="Upgrade Complete" footer={null} closable={false} maskClosable={false}>
            <Title level={4}>You’re all set!</Title>
            <Paragraph>
                Your account has been successfully upgraded to Partner status.
                You now have access to all Promotify features.
                To apply the changes, please log out and log back in.
            </Paragraph>
            <div style={{textAlign: 'right'}}>
                <Button type="primary" onClick={onLogout}>Log out</Button>
            </div>
        </Modal>
    );
};

export default UpgradeSuccessPage;